import axios from 'axios';

export const dashboard = async ({ year, newToken } = {}) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/dashboard?year=${year}`,
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const getClientData = async ({
  clientType,
  filterYear,
  newToken,
} = {}) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/dashboard/clients?year=${filterYear}&type=${clientType}`,
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const getInsurancesDetails = async ({
  clientType,
  filterYear,
  newToken,
} = {}) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/dashboard/insurances`,
      params: { year: filterYear, clientType },
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const compensi = async (params = {}) => {
  const {
    year,
    search,
    newToken,
    limit,
    offset,
    toBill,
    paid,
    admin,
    customer,
    number,
    supplier,
    accountabilityYear,
    accountabilityMonth,
    invoiceRef,
  } = params;
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/invoices`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        search,
        limit,
        offset,
        toBill,
        paid,
        admin,
        customer,
        number,
        supplier,
        accountabilityYear,
        accountabilityMonth,
        invoiceRef,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const compensiAssicurazioni = async (params = {}) => {
  const {
    newToken,
    year,
    limit,
    offset,
    insuranceStartYear,
    insuranceStartMonth,
    insuranceEndYear,
    insuranceEndMonth,
    policy_code,
    admin_cf,
    customer,
    customerType,
    active,
    agencyType,
  } = params;
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/insurances`,
      headers: {
        Authorization: newToken,
      },
      params: {
        limit,
        offset,
        insuranceStartYear,
        insuranceStartMonth,
        insuranceEndYear,
        insuranceEndMonth,
        policy_code,
        admin_cf,
        customer,
        customerType,
        active,
        agencyType,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const compensiStudio = async (params = {}) => {
  const { year, search, newToken, limit, offset, admin } = params;
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/studio-invoices/extra/earnings`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        search,
        limit,
        offset,
        admin,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

// export const insurances = async (params = {}) => {
//   const {
//     year,
//     search,
//     newToken,
//     limit,
//     offset,
//     paid,
//     toBill,
//     adminName,
//     contractor,
//     insuranceNumber,
//     supplier,
//     accountabilityYear,
//     accountabilityMonth,
//     invoiceRef,
//   } = params;
//   try {
//     const response = await axios({
//       method: 'get',
//       url: `${process.env.REACT_APP_API_URL}/insurances`,
//       headers: {
//         Authorization: newToken,
//       },
//       params: {
//         year,
//         search,
//         limit,
//         offset,
//         paid,
//         toBill,
//         adminName,
//         contractor,
//         insuranceNumber,
//         supplier,
//         accountabilityYear,
//         accountabilityMonth,
//         invoiceRef,
//       },
//     });

//     if (response instanceof Error) {
//       return { error: response };
//     }

//     return response;
//   } catch (error) {
//     // Sentry TODO
//     return { error };
//   }
// };
